import { render } from "./Mcp.vue?vue&type=template&id=4d64870e&scoped=true&ts=true"
import script from "./Mcp.vue?vue&type=script&lang=ts"
export * from "./Mcp.vue?vue&type=script&lang=ts"

import "./Mcp.vue?vue&type=style&index=0&id=4d64870e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d64870e"]])

export default __exports__